import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'baseui/snackbar'

import { breakManagementActions } from '../breakManagementSagas'
import { selectBreakManagement } from '../breakManagementSelectors'
import { setLimitModalOpen } from '../breakManagementSlice'

const useLimitReachedModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const { isLimitModalOpen, isSubmitting } = useSelector(selectBreakManagement)

  const setIsOpen = (isOpen: boolean) => {
    dispatch(setLimitModalOpen(isOpen))
  }

  const confirm = () => {
    dispatch({ type: breakManagementActions.START_BREAK, force: true, enqueue })
  }

  return {
    isOpen: isLimitModalOpen,
    isSubmitting,
    title: t('breakManagement:limit_modal.title'),
    text: t('breakManagement:limit_modal.text'),
    confirmLabel: t('breakManagement:start'),
    setIsOpen,
    confirm,
  }
}

export default useLimitReachedModal
